import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { EmptyPage } from '../EmptyPage';
import { getOrders, setSearch } from '../../redux/orderSlice';
import { Preloader } from '../../components/Preloader';
import { Orders } from '../../widgets/Orders';
import { MonthSwitcher } from '../../widgets/MonthSwitcher';
import { OrdersManager } from '../../widgets/Orders/OrdersManager';
import { Navigate } from 'react-router-dom';
import { accessor } from '../../helpers';
import { ColorSettings } from './ColorSettings';

export const OrdersPage = () => {

  const dispatch = useDispatch();
  const months = useSelector((state) => state.orders.months);
  const activeMonths = months.filter(m => m.active);

  useEffect(() => {
    dispatch(getOrders({
      month: activeMonths[activeMonths.length-1].month,
      multi: false,
  }));
  }, [])

  const isLoaded = useSelector((state) => state.orders.isLoaded);
  const orderError = useSelector((state) => state.orders.error);
  const userInfo = useSelector((state) => state.auth);
  const ordersAccess = accessor.orders(userInfo);

  const titles = useSelector((state) => state.settings.orderTitles);

  const orderSearch = useSelector((state) => state.orders.search);
  const setSearchHandler = (searchValue) => {
      localStorage.setItem('orderSearch', JSON.stringify(searchValue));
      dispatch(setSearch(searchValue));
  }

  const colorsData = useSelector(state => state.settings.orderColors); 
  const [colorState, setColorState] = useState(colorsData);

  if (!isLoaded) {
    return <Preloader />
  }
  if (!ordersAccess) {
    return <Navigate to="/users" />
  }
  if (orderError) {
    return <EmptyPage message={orderError}/>
  }



  return (
    <section className='orders-page page'>
      <ColorSettings setColorState={setColorState} colorState={colorState} />
      <OrdersManager titles={titles} searchSets={orderSearch} setSearchSets={setSearchHandler} />
      <Orders activeMonths={activeMonths} titles={titles} searchSets={orderSearch} colorState={colorState} />
      <MonthSwitcher months={months} />
    </section>
  )
}
